// src/pages/Blog.js
/* eslint-disable */
import React, { useEffect, useState, useCallback } from 'react';
import HelmetTemplate from '../utils/HelmetTemplate';
import { useParams } from 'react-router-dom';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import WebpageShell from './WebpageShell';

import BlogHeader from '../components/BlogHeader';
import BlogContent from '../components/BlogContent';

export default function Blog() {
  const { postId } = useParams();
  const [htmlContent, setHtmlContent] = useState('');
  const [metadata, setMetadata] = useState({
    title: 'Blog Title',
    author: 'Author',
    date: 'Date',
  });
  const [imageUrl, setImageUrl] = useState('');
  const [headers, setHeaders] = useState([]);

  // Fetch blog metadata and image URL from Firebase
  useEffect(() => {
    if (!postId) return;

    const fetchBlogData = async () => {
      try {
        // --- Fetch metadata from Firestore ---
        const db = getFirestore();
        const blogDocRef = doc(db, 'blogPosts', postId);
        const blogDocSnap = await getDoc(blogDocRef);
        if (blogDocSnap.exists()) {
          const data = blogDocSnap.data();
          setMetadata({
            title: data.title || 'Blog Title',
            author: data.author || 'Author',
            date: data.date || 'Date',
          });
        }

        // --- Fetch the banner image URL from Storage ---
        const storage = getStorage();
        const imageRef = ref(
          storage,
          `blog_posts/images/${postId}/${postId}-banner.jpg`
        );
        const url = await getDownloadURL(imageRef);
        setImageUrl(url);
      } catch (error) {
        // Swallow errors silently as in original file
      }
    };

    fetchBlogData();
  }, [postId]);

  // Fetch htmlContent and headers for BlogContent (same spot as before)
  useEffect(() => {
    // Your existing logic for fetching htmlContent and headers based on postId.
  }, [postId]);

  const handleScrollToHeader = useCallback((headerText) => {
    const id = headerText.replace(/\s+/g, '-').toLowerCase();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <WebpageShell
      navProps={{ addAnnouncementBar: false, isRecPrototypePage: false }}
      showCTA={true}
      showFooter={true}
    >
      <HelmetTemplate
        title={
          metadata.title
            ? `${metadata.title} - Blog - Match Medic`
            : 'Blog - Match Medic'
        }
        description="Welcome to Match Medic Blog – Find insights, tips, and stories to help you navigate your healthcare journey with confidence."
        canonicalUrl={`https://matchmedic.com/blog/${postId}`}
      />

      {/* Full-width BlogHeader inside the shell */}
      <section className="w-full mb-6">
        <BlogHeader metadata={metadata} imageUrl={imageUrl} />
      </section>

      {/* Centered reading width for article content */}
      <section className="max-w-7xl mx-auto px-4 lg:px-8">
        <BlogContent
          htmlContent={htmlContent}
          headers={headers}
          onHeaderClick={handleScrollToHeader}
        />
      </section>
    </WebpageShell>
  );
}
